import SurveyFormUpdateModal from './SurveyFormUpdateModal.vue';

export default SurveyFormUpdateModal;
